// Auto-generated file
export const APP_VERSION = "1.0.152";
